/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Reports {
    export interface IReportsHelper {
        reportNameToSecurityKey(reportName: string): string;
    }

    class ReportsHelper {
        static factory(): Function {
            const instance = () => {
                return new ReportsHelper();
            };

            instance.$inject = [];

            return instance;
        }

        public reportNameToSecurityKey(reportName: string): string {
            return reportName
                .replace(/ /g, '')
                .replace(/\-/g, '')
                .replace(/\//g, '')
                .toUpperCase();
        }
    }

    angular.module('meevo.plugins.reports')
        .factory('meevo.plugins.reports.ReportsHelper', ReportsHelper.factory());
}
